import * as Yup from 'yup';
import { INVALID_FIELDS, YupString } from './general';

export const signInSchema = Yup.object().shape({
  email: Yup.string().email().required(INVALID_FIELDS.REQUIRED),
  password: Yup.string().required(INVALID_FIELDS.REQUIRED),
});

export const TwoFASchema = Yup.object().shape({
  userCode: YupString.min(6, 'validation.messages.verifyCodeLength'),
});

export const OtpSchema = Yup.object().shape({
  otp: YupString.test(
    'not filled',
    'validation.messages.otpMustBeFilled',
    value => {
      if (value.length !== 6) return false;
      return true;
    },
  ),
  showCaptcha: Yup.boolean().nullable(),
  captcha: Yup.string().when('showCaptcha', {
    is: true,
    then: () => YupString.min(6, 'validation.messages.captchaLength'),
  }),
});
